import { useApiQuery } from '@/hooks/useApiQuery';
import { apiGet, operationsClient } from '@/lib/api/client';
import { customFieldEndpoints } from '@/lib/api/endpoints';
import { customFieldKeys } from '@/lib/queryKeys';
import type { CustomFieldDefinition } from '@/types/custom-fields';

export function useCustomFieldDefinitions(options: { enabled?: boolean } = {}) {
  return useApiQuery<CustomFieldDefinition[]>({
    queryKey: customFieldKeys.definitions(),
    queryFn: () =>
      apiGet<CustomFieldDefinition[]>(operationsClient, customFieldEndpoints.definitions()),
    enabled: options.enabled ?? true,
  });
}
